import { __rest } from '../../_virtual/_tslib.js';
import React__default from 'react';
import styled from 'styled-components';
import classnames from '../../node_modules/classnames/index.js';
import SvgIconLogin from '../../svgrComponents/baseIcons/IconLogin.js';
import { baseIconStyles } from '../utils/styles.js';
import { baseClassName, cursorPointerClassName } from '../utils/classes.js';
import { ariaLabelOrHidden, ariaFocusableNoLabel } from '../utils/aria.js';

const StyledIconLogin = styled((props) => {
    const { className, mousePointer, ariaLabel, color, fill, baseColor, highlightColor } = props, passProps = __rest(props, ["className", "mousePointer", "ariaLabel", "color", "fill", "baseColor", "highlightColor"]);
    return (React__default.createElement(SvgIconLogin, Object.assign({ className: classnames(baseClassName, className, {
            [cursorPointerClassName]: !!mousePointer
        }) }, passProps, ariaLabelOrHidden(ariaLabel), ariaFocusableNoLabel(ariaLabel))));
}) `
  ${baseIconStyles}
`;
const IconLogin = (props) => {
    return React__default.createElement(StyledIconLogin, Object.assign({}, props));
};
IconLogin.displayName = 'Icon';

export { IconLogin };
//# sourceMappingURL=Login.js.map
